import { useMemo } from 'react';
import { useOpts } from '../../context';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING } from '../../consts/routing-number-mappings';
import { checkHackyWorkspace } from '../../utils/hacky-workspace-customizations';
function useBankInfoInputSubtitle() {
    var getLocalizedString = useGetLocalizedString();
    var workspaceName = useOpts().linkTokenPayload.workspaceName;
    var subtitleText = useMemo(function () {
        if (workspaceName in WORKSPACE_TO_SINGLE_ROUTING_NO_MAPPING) {
            return getLocalizedString('ENTER_ACCOUNT_NUMBER');
        }
        if (checkHackyWorkspace('Y12', workspaceName)) {
            return getLocalizedString('ENTER_ACCOUNT_NUMBER_Y12');
        }
        return getLocalizedString('ENTER_ROUTING_AND_ACCOUNT_NUMBER');
    }, [getLocalizedString, workspaceName]);
    return subtitleText;
}
export default useBankInfoInputSubtitle;
